(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[879,77],{

/***/ 850:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/staking",
      function () {
        return __webpack_require__(2690);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _Spinner__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6746);




function Button(param) {
    var children = param.children, onClick = param.onClick, href = param.href, _type = param.type, type = _type === void 0 ? "button" : _type, target = param.target, loading = param.loading, disabled = param.disabled, _theme = param.theme, theme = _theme === void 0 ? "primary" : _theme, className = param.className, link = param.link;
    var themeClasses = "text-bg bg-theme-1 border-theme-1 hover:bg-transparent hover:border-theme-1 transition duration-300 hover:text-theme-1";
    if (theme === "outline") {
        themeClasses = "text-theme-1 border-theme-1 hover:bg-theme-1 hover:text-white";
    }
    if (theme === "link") {
        themeClasses = "border-transparent text-theme-1 hover:text-theme-1";
    }
    if (disabled) {
        themeClasses = "opacity-50 cursor-not-allowed";
    }
    var classes = "inline-flex items-center px-4 py-2 border-2 text-sm font-bold uppercase rounded-md transition-all duration-200 tracking-wide text-center justify-center ".concat(themeClasses, " ").concat(className);
    if (link && href) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: href,
            target: target,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                className: classes,
                children: children
            })
        });
    }
    if (href) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: href,
            target: target,
            className: classes,
            children: children
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        type: type,
        disabled: disabled,
        onClick: onClick,
        className: classes,
        children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Spinner__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            dimensionClasses: "w-5 h-5"
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: children
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 6770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2679);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8893);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Spinner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6746);





function NftImage(param) {
    var nft = param.nft, spinnerDimensionClasses = param.spinnerDimensionClasses;
    var ref, ref1;
    var imageId = null;
    if (nft === null || nft === void 0 ? void 0 : (ref = nft.params) === null || ref === void 0 ? void 0 : ref.url) {
        var ref2;
        imageId = nft === null || nft === void 0 ? void 0 : (ref2 = nft.params) === null || ref2 === void 0 ? void 0 : ref2.url.split("ipfs://")[1];
    }
    var imageUrl = "https://ipfs.io/ipfs/".concat(imageId);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative flex items-center justify-center w-full bg-gray-800 aspect-square",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2__.LazyLoadImage, {
                height: 400,
                width: 400,
                src: imageUrl,
                alt: nft === null || nft === void 0 ? void 0 : (ref1 = nft.params) === null || ref1 === void 0 ? void 0 : ref1.name,
                effect: "blur",
                wrapperClassName: "absolute inset-0 !w-full !h-full z-10"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Spinner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                dimensionClasses: spinnerDimensionClasses
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (NftImage);


/***/ }),

/***/ 7031:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2369);



function PageHeader(param) {
    var heading = param.heading, description = param.description, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "max-w-2xl mx-auto mt-5 mb-10",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "space-y-4 text-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: "text-3xl font-extrabold tracking-tight text-neutral-200 sm:text-5xl md:text-6xl",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "block xl:inline",
                            children: heading
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mx-auto space-y-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-base text-neutral-500 md:text-xl",
                                children: description
                            }),
                            children
                        ]
                    })
                ]
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (PageHeader);


/***/ }),

/***/ 6746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


function Spinner(param) {
    var _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? 4 : _strokeWidth, _dimensionClasses = param.dimensionClasses, dimensionClasses = _dimensionClasses === void 0 ? "w-16 h-16" : _dimensionClasses;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            className: "".concat(dimensionClasses, " text-white animate-spin"),
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                    className: "opacity-25",
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    strokeWidth: strokeWidth
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    className: "opacity-75",
                    fill: "currentColor",
                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Spinner);


/***/ }),

/***/ 2690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ staking; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/Container.js
var Container = __webpack_require__(2369);
// EXTERNAL MODULE: ./components/PageHeader.js
var PageHeader = __webpack_require__(7031);
;// CONCATENATED MODULE: ./components/StakingInfo.js

/* This example requires Tailwind CSS v2.0+ */ var faqs = [
    {
        id: 1,
        question: "How much KARMA can I earn per week?",
        answer: "Each week you will earn 5 KARMA for every AlgoDaruma you have staked."
    },
    {
        id: 2,
        question: "When/how do I receive the KARMA?",
        answer: "Once a week the KARMA will be air dropped directly to your wallet for every AlgoDaruma you have staked."
    },
    {
        id: 3,
        question: "What happens when I list/sell/transfer an AlgoDaruma that is being staked?",
        answer: "Your AlgoDaruma will be unstaked as soon as you list or transfer your AlgoDaruma to another wallet. You will not receive the weekly rewards."
    }, 
];
function StakingInfo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mt-12 md:mt-36",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "max-w-6xl mx-auto",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-gray-800 rounded-lg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "px-4 py-16 mx-auto max-w-7xl sm:py-24 sm:px-6 lg:px-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-3xl font-extrabold text-gray-50",
                            children: "How does staking work?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pt-10 mt-6 border-t border-gray-300 border-opacity-25",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("dl", {
                                className: "space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-12",
                                children: faqs.map(function(faq) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                className: "text-lg font-medium leading-6 text-gray-50",
                                                children: faq.question
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                className: "mt-2 text-base text-gray-400",
                                                children: faq.answer
                                            })
                                        ]
                                    }, faq.id);
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./components/NftImage.js
var NftImage = __webpack_require__(6770);
// EXTERNAL MODULE: ./components/Button.js
var Button = __webpack_require__(2077);
// EXTERNAL MODULE: ./hooks/useStaking.js
var useStaking = __webpack_require__(2556);
// EXTERNAL MODULE: ./hooks/useAlgo.js
var useAlgo = __webpack_require__(9246);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs
var react_toastify_esm = __webpack_require__(5678);
;// CONCATENATED MODULE: ./components/StakingPreview.js









function StakingPreview(param) {
    var daruma = param.daruma;
    var ref;
    var optIn = (0,useAlgo/* useAlgo */.t1)().optIn;
    var ref1 = (0,useStaking/* useStaking */.n)(), stakeDaruma = ref1.stakeDaruma, myEligibleDarumas = ref1.myEligibleDarumas, stakedDarumas = ref1.stakedDarumas;
    var ref2 = (0,react.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var isEligible = myEligibleDarumas.map(function(it) {
        return it.index;
    }).includes(daruma.index);
    var isStaked = stakedDarumas.map(function(it) {
        return it.index;
    }).includes(daruma.index);
    var buttonLabel = "Stake";
    if (isStaked) {
        buttonLabel = "Staked";
    } else if (!isEligible) {
        buttonLabel = "Not eligible";
    }
    var onStake = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(shouldStake) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.prev = 1;
                        if (!shouldStake) {
                            _ctx.next = 5;
                            break;
                        }
                        _ctx.next = 5;
                        return optIn(parseInt("832356628"));
                    case 5:
                        _ctx.next = 7;
                        return stakeDaruma(daruma, shouldStake);
                    case 7:
                        _ctx.next = 13;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](1);
                        console.log(_ctx.t0);
                        react_toastify_esm/* toast.error */.Am.error("Error staking");
                    case 13:
                        _ctx.prev = 13;
                        setLoading(false);
                        return _ctx.finish(13);
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    9,
                    13,
                    16
                ]
            ]);
        }));
        return function onStake(shouldStake) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative mb-2 overflow-hidden bg-gray-800 rounded-md aspect-square",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NftImage/* default */.Z, {
                    nft: daruma,
                    spinnerDimensionClasses: "w-12 h-12"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-lg font-bold text-gray-500",
                        children: daruma === null || daruma === void 0 ? void 0 : (ref = daruma.params) === null || ref === void 0 ? void 0 : ref.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-base italic text-gray-500",
                        children: "Earns 5 KARMA per staking period"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "space-y-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        disabled: !isEligible || isStaked,
                        onClick: function() {
                            return onStake(true);
                        },
                        loading: loading,
                        className: "w-full",
                        children: buttonLabel
                    }),
                    isStaked && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        theme: "link",
                        onClick: function() {
                            return onStake(false);
                        },
                        loading: loading,
                        className: "w-full",
                        children: "Unstake"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var components_StakingPreview = (StakingPreview);

// EXTERNAL MODULE: ./config.js
var config = __webpack_require__(1838);
// EXTERNAL MODULE: ./hooks/useCollection.js
var useCollection = __webpack_require__(2338);
;// CONCATENATED MODULE: ./pages/staking/index.js













var ConnectWalletButton = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(409), __webpack_require__.e(924), __webpack_require__.e(201), __webpack_require__.e(299)]).then(__webpack_require__.bind(__webpack_require__, 8117));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8117)
            ];
        }
    },
    ssr: false
});
function Staking() {
    var myDarumas = (0,useCollection/* useCollection */.K)().myDarumas;
    var address = (0,useAlgo/* useAlgo */.t1)().address;
    var ref = (0,useStaking/* useStaking */.n)(), totalStaked = ref.totalStaked, currentPeriod = ref.currentPeriod;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "Staking - ".concat(config/* default.siteName */.Z.siteName)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
                heading: "Staking",
                description: "Stake your AlgoDaruma for KARMA.",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-lg font-medium text-gray-500",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "Total Staked:"
                                }),
                                " ",
                                totalStaked
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-lg font-medium text-gray-500",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "Staking Period:"
                                }),
                                " ",
                                currentPeriod.start,
                                " - ",
                                currentPeriod.end
                            ]
                        })
                    ]
                })
            }),
            address ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                className: (0,clsx_m/* default */.Z)(" mx-auto grid gap-5", myDarumas.length === 1 ? "mx-auto grid-cols-1 max-w-[400px]" : "grid-cols-1 md:grid-cols-3 max-w-6xl"),
                children: myDarumas.map(function(it, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_StakingPreview, {
                        daruma: it
                    }, index);
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StakingInfo, {})
        ]
    });
}
/* harmony default export */ var staking = (Staking);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [143,774,888,179], function() { return __webpack_exec__(850); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);